import {IAbTestingStrategy} from "./ab-testing-strategy.interface";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {NullableString} from "../../../../common/types/nullable-types";
import {
    AB_TESTING_ANONYMOUS_PLAYER_ID_STORAGE_KEY,
    AB_TESTING_DATA_FOR_AUTHORIZED_USER_STORAGE_KEY
} from "../ab-testing-local-storage-keys";
import {IAbTestingData, IAbTestingFeature} from "../ab-testing-feature-data-provider.service.interface";

export const EmptyAbTestData: IAbTestingData = {
    ErrorDescription: "",
    Features: {},
    AnonymousPlayerId: null
}

export abstract class AbTestingBaseStrategy implements IAbTestingStrategy {
    constructor(protected readonly services: IServiceFactoryExtended) {

    }

    abstract getFeature(featureName: string): IAbTestingFeature | null;
    abstract waitForLoadTestData(): Promise<void>;

    get anonymousPlayerId(): NullableString {
        return this.services.localStorage.getItem(AB_TESTING_ANONYMOUS_PLAYER_ID_STORAGE_KEY);
    }

    protected set anonymousPlayerId(value:  NullableString) {
        if(value) {
            this.services.localStorage.setItem(AB_TESTING_ANONYMOUS_PLAYER_ID_STORAGE_KEY, value);
        } else {
            this.services.localStorage.removeItem(AB_TESTING_ANONYMOUS_PLAYER_ID_STORAGE_KEY);
        }
    }

    protected _readAuthorizedTestDataFromLocalStorage(): IAbTestingData {
        return this.services.localStorage.getJson<IAbTestingData>(AB_TESTING_DATA_FOR_AUTHORIZED_USER_STORAGE_KEY) ?? EmptyAbTestData;
    }

    protected _findFeature(featureName: string, testData: IAbTestingData): IAbTestingFeature | null {
        if(!featureName || !testData || !testData.Features) {
            return null;
        }


        const feature = testData.Features[featureName.toLowerCase()];
        if(!feature) {
            return null;
        }

        if(!feature.Properties) {
            return null;
        }

        if(Object.keys(feature.Properties).length === 0) {
            return null;
        }

        return feature;
    }


    abstract testData(): Promise<IAbTestingData>;
}